<template>
  <div v-editable="blok" class="flex size-full flex-col">
    <div class="relative flex size-full flex-col rounded-double border-2 border-text bg-back-accent p-5 text-text">
      <component
        :is="blok.headline_strikethrough ? 's' : 'h3'"
        class="z-10 text-xl font-bold decoration-green-dark decoration-[3px]"
        :class="{ 'line-through': blok.headline_strikethrough }"
      >
        {{ blok.headline }}
      </component>
      <div class="prose prose-base z-10 pt-4 dark:prose-invert empty:hidden" v-html="text" />

      <div v-if="blok.buttonLink && blok.buttonText" class="mt-auto flex w-full justify-start pt-6">
        <sb-link :link="blok.buttonLink" class="button extra-small button-invert inline-flex">
          {{ blok.buttonText }}
          <nuxt-icon name="chevron-right" class="ml-auto pl-4" filled />
        </sb-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CardTextStoryblok } from "~/storyblok-component-types"

const props = defineProps<{ blok: CardTextStoryblok; }>()

const text = renderRTF(props.blok.text)
</script>
